import messages_en from '../locales/en.json';
import messages_np from '../locales/np.json';
import messages_ph from '../locales/ph.json';
import messages_cn from '../locales/cn.json';
import messages_chn from '../locales/chn.json';
import messages_jp from '../locales/jp.json';
import messages_id from '../locales/id.json';
import messages_vn from '../locales/vn.json';
import messages_mm from '../locales/mm.json';
export const messages = {
  en: messages_en,
  np: messages_np,
  ph: messages_ph,
  cn: messages_cn,
  chn: messages_chn,
  jp: messages_jp,
  id: messages_id,
  vn: messages_vn,
  mm: messages_mm,
};

export const options =
  [{index:"1",label:"EN - English",value:"en"},
{index:"2",label:"NP - नेपाली",value:"np"},
{index:"3",label:"PH - Tagalog",value:"ph"},
{index:"4",label:"CN - 简体中文",value:"cn"},
{index:"5",label:"CN - 繁體中文",value:"chn"},
{index:"6",label:"JP - 日本語",value:"jp"},
{index:"7",label:"ID - Bahasa Indonesia",value:"id"},
{index:"8",label:"VN - Tiếng Việt",value:"vn"},
{index:"9",label:"MM - မြန်မာ (မြန်မာ)၊",value:"mm"}
];

export const severProperties = 
{
  serverURL: "https://jimsapplicantportal.cloud.iom.int/app",
  serverCORS: "https://jimsapplicantportal.cloud.iom.int"
}
